import { render, staticRenderFns } from "./nppartcode.vue?vue&type=template&id=ff7fbbf4&scoped=true&"
import script from "./nppartcode.vue?vue&type=script&lang=js&"
export * from "./nppartcode.vue?vue&type=script&lang=js&"
import style0 from "./nppartcode.vue?vue&type=style&index=0&id=ff7fbbf4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7fbbf4",
  null
  
)

export default component.exports